import { APIClient } from "../apiCore";
import * as url from "../urls";
import {m9sGlobals} from "../../config";
import {MainMetaType} from "../../redux/Main/common";
import {createPaginationQuery} from "../../helpers/functions";

const api = new APIClient();

const getSaleStores = (data:MainMetaType) => {
    const query = createPaginationQuery(data)
  return api.get(m9sGlobals.CURRENT_CABINET+url.GET_SALE_STORES+"?"+query);
};

const sendDataSaleStore = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.UPDATE_SALE_STORE, data);
};

const removeSaleStore = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.REMOVE_SALE_STORE, data);
};

export {
    getSaleStores,
    sendDataSaleStore,
    removeSaleStore
};
